/**
 * 项目上下文提供者
 */
import React, { createContext, useContext } from 'react';

const ProjectContext = createContext(undefined);

export const ProjectProvider = ({ project, readOnly = false, children }) => {
  return (
    <ProjectContext.Provider value={{ project, readOnly }}>
      {children}
    </ProjectContext.Provider>
  );
};

export const useProject = () => {
  const context = useContext(ProjectContext);
  if (!context) {
    throw new Error('useProject must be used within a ProjectProvider');
  }
  return context;
};

